/* eslint-disable react/no-danger */

import React from 'react';
import { string, shape, number } from 'prop-types';

import ProgressBar from '../../full-shipping-snackbar/components/progress-bar-default';
import TitleSection from './title-section';

const namespace = 'ui-search-fullsnackbar';

/**
 * TextSection component
 *
 * @component
 * @param {Object} props
 * @param {Object} props.title - Title configuration
 * @param {string} props.firstText - First text to display
 * @param {string} props.lastText - Last text to display
 * @param {Object} props.progressBar - Progress bar configuration
 * @param {Object} props.epigraph - Epigraph configuration
 * @returns {React.ReactElement} The text section component
 */

const TextSection = ({ title, firstText, lastText, progressBar, epigraph }) => (
  <div className={`${namespace}__text-container`}>
    <TitleSection title={title} firstText={firstText} lastText={lastText} />
    {progressBar?.percent > 0 && <ProgressBar progress_bar={progressBar} namespace={namespace} />}
    {epigraph?.first_text && (
      <div className={`${namespace}__bottom`}>
        <span className={`${namespace}__subtext`} dangerouslySetInnerHTML={{ __html: epigraph.first_text }} />
      </div>
    )}
  </div>
);

TextSection.propTypes = {
  epigraph: shape({
    first_text: string,
    last_text: string,
  }),
  firstText: string,
  lastText: string,
  progressBar: shape({
    percent: number,
    color: string,
    color_hex: string,
  }),
  title: shape({
    first_text: string,
    last_text: string,
    asset_image: string,
  }),
};

export default TextSection;
